import React, { useEffect, useMemo, useRef, useState } from 'react';
import { showSuccessToast } from '../../../../utils/toastHelper';
import { updatePermissions } from '../../services/permissionsService';
import DeletePermissionModal from './DeletePermissionModal';
import { useTranslation } from 'react-i18next';
export default function EditPermissionModal({
  modalData,
  permissionsTypes,
  handleEditPermissionSubmit,
  isOpen,
  onClose,
  isDeleteOpen,
  deleteUser,
  handleOpenModal,
}) {
  const closeRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation('permissions');
  const initialPermissionsState = useMemo(() => {
    return permissionsTypes.reduce((acc, permissionType) => {
      const userPermission = modalData?.permissions?.find(
        (perm) => perm.permission_type.id === permissionType.id
      );

      acc[permissionType.id] = {
        // add: userPermission?.add_permission || false,
        view: userPermission?.view_permission || false,
        edit: userPermission?.edit_permission || false,
      };
      return acc;
    }, {});
  }, [modalData, permissionsTypes]);
  const [permissionsState, setPermissionsState] = useState(
    initialPermissionsState
  );

  useEffect(() => {
    setPermissionsState(initialPermissionsState);
  }, [initialPermissionsState]);
  useEffect(() => {
    const modalElement = document.getElementById('edit-permissions');
    const modalInstance = new window.bootstrap.Modal(modalElement, {
      backdrop: 'static',
      keyboard: false,
    });

    if (isOpen) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
    return () => {
      modalInstance.hide();
    };
  }, [isOpen]);

  const handleCheckboxChange = (permissionTypeId, permissionType, e) => {
    const checked = e.target.checked;

    setPermissionsState((prevState) => {
      const currentPermissions = prevState[permissionTypeId] || {};
      let updatedPermissions = {
        ...currentPermissions,
        [permissionType]: checked,
      };

      // Rule 1: If "edit" is selected, ensure "view" is also selected
      if (permissionType === 'edit' && checked) {
        updatedPermissions.view = true;
      }

      // Rule 2: If "view" is unselected, unselect "edit" as well
      if (permissionType === 'view' && !checked) {
        updatedPermissions.edit = false;
      }

      return {
        ...prevState,
        [permissionTypeId]: updatedPermissions,
      };
    });
  };
  const handleSelectAll = (permissionType, isChecked) => {
    const updatedState = { ...permissionsState };

    Object.keys(updatedState).forEach((permissionTypeId) => {
      if (permissionType === 'edit') {
        // Selecting/deselecting edit must also affect view
        updatedState[permissionTypeId].edit = isChecked;
        if (isChecked) {
          updatedState[permissionTypeId].view = true; // ensure view is checked if edit is checked
        }
      } else if (permissionType === 'view') {
        updatedState[permissionTypeId].view = isChecked;
        if (!isChecked) {
          updatedState[permissionTypeId].edit = false; // uncheck edit if view is unchecked
        }
      }
    });

    setPermissionsState(updatedState);
  };

  const isSelectAllChecked = (permissionType) => {
    return Object.values(permissionsState).every(
      (permissions) => permissions[permissionType]
    );
  };

  const handleSubmit = async () => {
    setLoading(true);
    const permissionDataToSend = Object.keys(permissionsState).map(
      (permissionTypeId) => {
        const permission = permissionsState[permissionTypeId];
        return {
          permission_id: permissionTypeId,
          // add_permission: permission.add ? 1 : 0,
          view_permission: permission.view ? 1 : 0,
          edit_permission: permission.edit ? 1 : 0,
        };
      }
    );

    const dataToSend = {
      permissions: permissionDataToSend,
      user_id: modalData.id,
    };
    await handleEditPermissionSubmit(dataToSend);

    setLoading(false);
  };

  return (
    <>
      <div
        className="modal fade"
        id="edit-permissions"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="staticBackdropLabel">
                {t('EDITPERMISSIONS')}
              </h1>
              <button
                type="button"
                className="btn-close"
                // data-bs-dismiss="modal"
                // aria-label="Close"
                // ref={closeRef}
                onClick={() => {
                  onClose('edit');
                }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="users">
                <div className="profile">
                  <span>
                    <img src="images/empty-user.png" alt="" />
                  </span>
                  <div className="profile-text">
                    <h5>{modalData.name}</h5>
                    <h6>{modalData.email}</h6>
                  </div>
                </div>
                <button
                  className="delete"
                  onClick={() => handleOpenModal('delete', modalData)}
                >
                  <img src="images/red-delete.svg" alt="" />
                </button>
              </div>
              <div className="table-outer permissions">
                <table className="table">
                  <thead>
                    <tr className="t-heading">
                      <th className="permissions-type">
                        <h5>{t('PERMISSIONSTYPE')}</h5>
                      </th>
                      <th className="permission">
                        <div className="checkbox-container">
                          <ul>
                            <li>
                              {/* <label className="custom-checkbox">
                              <input type="checkbox"   checked={isSelectAllChecked("add")}
                onChange={(e) => handleSelectAll("add", e.target.checked)} />
                              <span className="checkmark"></span>
                              <span className="label-text">Add</span>
                            </label> */}
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={isSelectAllChecked('view')}
                                  onChange={(e) =>
                                    handleSelectAll('view', e.target.checked)
                                  }
                                />
                                <span className="checkmark"></span>
                                <span className="label-text">{t('VIEW')}</span>
                              </label>
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  checked={isSelectAllChecked('edit')}
                                  onChange={(e) =>
                                    handleSelectAll('edit', e.target.checked)
                                  }
                                />
                                <span className="checkmark"></span>
                                <span className="label-text">
                                  {t('CHANGE')}
                                </span>
                              </label>
                            </li>
                          </ul>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {permissionsTypes.map(
                      (permissionType, permissionTypeIndex) => {
                        // const userPermission = modalData?.permissions?.find(
                        //   (perm) =>
                        //     perm?.permission_type?.id === permissionType.id
                        // );
                        // console.log("user per", userPermission);
                        return (
                          <tr key={permissionTypeIndex}>
                            <td className="permissions-type">
                              <h5>{t(permissionType.key)}</h5>
                            </td>
                            <td className="permission">
                              <div className="checkbox-container">
                                <ul>
                                  <li>
                                    {/* <label className="custom-checkbox">
                                    <input
                                      type="checkbox"
                                      checked={
                                        permissionsState[permissionType.id]
                                          ?.add || false
                                      }
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          permissionType.id,
                                          "add",
                                          e
                                        )
                                      }
                                    />

                                    <span className="checkmark"></span>
                                    <span className="label-text">Add</span>
                                  </label> */}
                                    <label className="custom-checkbox">
                                      <input
                                        type="checkbox"
                                        checked={
                                          permissionsState[permissionType.id]
                                            ?.view || false
                                        }
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            permissionType.id,
                                            'view',
                                            e
                                          )
                                        }
                                      />

                                      <span className="checkmark"></span>
                                      <span className="label-text">
                                        {t('VIEW')}
                                      </span>
                                    </label>
                                    <label className="custom-checkbox">
                                      <input
                                        type="checkbox"
                                        checked={
                                          permissionsState[permissionType.id]
                                            ?.edit || false
                                        }
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            permissionType.id,
                                            'edit',
                                            e
                                          )
                                        }
                                      />

                                      <span className="checkmark"></span>
                                      <span className="label-text">
                                        {t('CHANGE')}
                                      </span>
                                    </label>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        );
                      }
                    )}
                  </tbody>
                </table>
              </div>
              <div className="bottom-button">
                <div className="row">
                  <div className="col-sm-6">
                    <button
                      className="cancel"
                      onClick={() => {
                        onClose('edit');
                      }}
                    >
                      {t('CANCEL')}
                    </button>
                  </div>
                  <div className="col-sm-6">
                    <button onClick={handleSubmit} className="save">
                      {loading ? t('LOADING') + '...' : t('SAVE')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DeletePermissionModal
        modalData={modalData}
        isOpen={isDeleteOpen}
        onClose={onClose}
        deleteUser={deleteUser}
      />
    </>
  );
}
